<template>
   <div class="content-wrapper">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-6">
               <h1>Add New Billing Account</h1>
            </div>
            <div class="col-xs-6 mandatoryDiv">
               <span class="mandatory_color">(*)</span> <span class="letter-right"> Marked are required field</span>
            </div>
         </div>
      </section>
      <section class="content">
         <div class="row">
            <form role="form" id="formID">
               <div class="col-sm-12">
                  <div class="alert alert-info" v-if="error_message">
                     {{error_message}}
                  </div>
               </div>
               <div class="col-sm-6">
                  <div class="box">
                     <div class="box-header">
                        <h3 class="box-title">
                           Account Informations
                        </h3>
                     </div>
                     <div class="box-body form-box-body form-horizontal">
                        <div class="form-group">
                           <label class="col-md-4 control-label">Payment Channel <span class="mandatory_horizontal">*</span></label>
                           <div class="col-md-8">
                              <select title="" name="payment_method" id="payment_method" class="form-control input-sm" v-model="payment_method" @change="loadGatewarArr">
                                 <option value="">-- Select --</option>
                                 <option v-for="(val, index) in payment_method_arr" :value="index">
                                    {{val}}
                                 </option>
                              </select>
                              <label v-if="error_payment_method" class="error" for="payment_method">{{error_payment_method}}</label>
                           </div>
                        </div>

                        <div class="form-group">
                           <label class="col-md-4 control-label">Name <span class="mandatory_horizontal">*</span></label>
                           <div class="col-md-8">
                              <select title="" name="payment_gateway_type" id="payment_gateway_type" class="form-control input-sm" v-model="payment_gateway_type">
                                 <option value=""> -- Select -- </option>
                                 <option v-for="(val2, index2) in selected_gateways_arr" :value="index2">
                                    {{val2}}
                                 </option>
                              </select>
                              <label v-if="error_payment_gateway_type" class="error" for="payment_gateway_type">{{error_payment_gateway_type}}</label>
                           </div>
                        </div>

                        <div class="form-group">
                           <label class="col-md-4 control-label">Account Name <span class="mandatory_horizontal">*</span></label>
                           <div class="col-md-8">
                              <input name='acc_name' id='acc_name' class="form-control input-sm" value='' placeholder="Enter Account Name" type="text" v-model="acc_name">
                              <label v-if="error_acc_name" class="error" for="acc_name">{{error_acc_name}}</label>
                           </div>
                        </div>

                        <div class="form-group">
                           <label class="col-md-4 control-label">Account Number <span class="mandatory_horizontal">*</span></label>
                           <div class="col-md-8">
                              <input name='acc_number' id='acc_number' class="form-control input-sm" value='' placeholder="Enter Account Number" type="text" v-model="acc_number">
                              <label v-if="error_acc_number" class="error" for="acc_number">{{error_acc_number}}</label>
                           </div>
                        </div>

                        <div class="form-group" v-if="bank_selected">
                           <label class="col-md-4 control-label">Routing Number <span class="mandatory_horizontal">*</span></label>
                           <div class="col-md-8">
                              <input name='routing_number' id='routing_number' class="form-control input-sm" value='' placeholder="Enter Routing Number" type="text" v-model="routing_number">
                              <label v-if="error_routing_number" class="error" for="routing_number">{{error_routing_number}}</label>
                           </div>
                        </div>

                        <div class="form-group" v-if="bank_selected">
                           <label class="col-md-4 control-label">Swift Code <span class="mandatory_horizontal">*</span></label>
                           <div class="col-md-8">
                              <input name='swift_code' id='swift_code' class="form-control input-sm" value='' placeholder="Enter Swift Code" type="text" v-model="swift_code">
                              <label v-if="error_swift_code" class="error" for="swift_code">{{error_swift_code}}</label>
                           </div>
                        </div>

                        <div class="form-group">
                           <label class="col-md-4 control-label">Active</label>
                           <div class="col-md-8">
                              <input name="status"  type="checkbox" id="status" value="1" v-model="status" />
                           </div>
                        </div>

                     </div>
                  </div>

                  <div class="col-sm-12 btnRight">
                     <input type="submit" name="submit" value="Submit" class="btn btn-sm btn-submit btn-submit-big" @click="formSubmit"/>
                  </div>
               </div>
         
            </form>
         </div>
      </section>
   </div>
</template>
<script>
   import axios from 'axios'
   export default {
      name: "AddBillingAccount",
      data() {
         return {
            payment_method_arr : {},
            payment_method : '',
            payment_gateways_str : '',
            selected_gateways_arr : [],
            status : true,
            payment_gateway_type : '',
            acc_name : '',
            acc_number : '',
            routing_number : '',
            swift_code : '',
            bank_selected : false,
            account_id : '',
            edit : false,
            editData : {},
            
            error_message : '',
            error_payment_method : false,
            error_payment_gateway_type : false,
            error_acc_name : false,
            error_acc_number : false,
            error_routing_number : false,
            error_swift_code : false,

         }
      },
      methods: {
         formSubmit(e) {
            e.preventDefault();
            var rootObject = this;

            var result = this.fromValidation();
            if (result) {
               setTimeout(function(){  
                  rootObject.error_payment_method = false;
                  rootObject.error_payment_gateway_type = false;
                  rootObject.error_acc_name = false;
                  rootObject.error_acc_number = false;
                  rootObject.error_routing_number = false;
                  rootObject.error_swift_code = false;
               }, 2000);
               return 0;
            }

            loader.show();
            const form = new FormData()

            let status = 1;
            if(!this.status){
               status = 0; 
            }

            form.append('payment_method', this.payment_method)
            form.append('payment_gateway_type', this.payment_gateway_type)
            form.append('acc_name', this.acc_name)
            form.append('acc_number', this.acc_number)
            form.append('routing_number', this.routing_number)
            form.append('status', status)
            form.append('swift_code', this.swift_code)

            if(this.edit){
               form.append('id', this.account_id)
            }

            var config = {
             headers: { 'Content-Type': 'multipart/form-data' }
            }

            axios.post('affiliate/billing-acounts', form, config)
            .then(function (response) {
               //console.log(response);
               if(rootObject.edit){
                  rootObject.error_message =  "Account Details Successfully Updated";
               }else{
                  rootObject.error_message =  "Account Details Successfully Added";
               }
               
               loader.hide();
               setTimeout(function(){
                  if(!rootObject.edit){
                     rootObject.resetForm();
                  }
                  rootObject.error_message = '';
               }, 2000);
            })
            .catch(function (error) {
               let alertmessage = "";
               for (var prop in error.response.data) {
                   alertmessage += ' '+error.response.data[prop]
               }
               console.log(alertmessage);
               loader.hide();
               rootObject.com_errorHandel(error);
               rootObject.error_message =  alertmessage;
               setTimeout(function(){  
                  rootObject.error_message = '';
               }, 2000);
            });
         },

         fromValidation(reset = false){
            var has_error = false;
            this.error_payment_method = false;
            this.error_payment_gateway_type = false;
            this.error_acc_name = false;
            this.error_acc_number = false;
            this.error_routing_number = false;
            this.error_swift_code = false;

            if(!this.payment_method){
               this.error_payment_method = "This field is required";
               has_error = true;
            }

            if(!this.payment_gateway_type){
               this.error_payment_gateway_type = "This field is required";
               has_error = true;
            }

            if(!this.acc_name){
               this.error_acc_name = "This field is required";
               has_error = true;
            }

            if(!this.acc_number){
               this.error_acc_number = "This field is required";
               has_error = true;
            }

            if(this.payment_method==1){
               if(!this.routing_number){
                  this.error_routing_number = "This field is required";
                  has_error = true;
               }
               
               if(!this.swift_code){
                  this.error_swift_code = "This field is required";
                  has_error = true;
               }
            }

            if (has_error) {
               return true;
            }else{
               return false;
            }
         },

         resetForm(){
            var has_error = false;
            this.payment_gateway_type = '';
            this.acc_name = '';
            this.acc_number = '';
            this.routing_number = '';
            this.swift_code = '';
         },

         loadGatewarArr(){
            this.selected_gateways_arr = {};
            var payment_method = this.payment_method;
            var gateways_arr = JSON.parse(this.payment_gateways_str);
            if(parseInt(payment_method) > 0){
               this.selected_gateways_arr = gateways_arr[payment_method];
            }
            this.payment_gateway_type = '';

            if(payment_method==1){
               this.bank_selected = true;
            }else{
               this.bank_selected = false;
            }
         },

         loadEditData(){
            //console.log(this.editData);
            var rootObject = this;
            this.payment_method = this.editData.payment_channel_id;
            this.loadGatewarArr();
            setTimeout(function(){
               rootObject.status = rootObject.editData.status;
               rootObject.payment_gateway_type = rootObject.editData.payment_method_type;
               rootObject.acc_name = rootObject.editData.acc_name;
               rootObject.acc_number = rootObject.editData.acc_number;
               if(rootObject.editData.routing_number){
                  rootObject.routing_number = rootObject.editData.routing_number;   
               }
               if(rootObject.editData.swift_code){
                  rootObject.swift_code = rootObject.editData.swift_code;
               }
               loader.hide();
            }, 500);
         }
      },
      created(){
         this.com_user_type_access([1,2], true);
         loader.show();
         var rootObject = this;

         var encryptedData = rootObject.$store.getters.getUser;
         var decodedString  = rootObject.com_DecryptString(encryptedData);
         var userData = JSON.parse(decodedString);
         if(userData.user_level == 1) {
            this.$router.push('dashboard');
         }

         var queryStr = "";
         if(this.$route.params.id){
            this.account_id = this.$route.params.id;
            this.edit = true;
            queryStr = "?id="+this.$route.params.id;
         }
         
         axios.get('affiliate/create-edit-billing-acounts'+queryStr).then(function (response) {
            rootObject.payment_method_arr = response.data.payment_method_type;
            rootObject.payment_gateways_str = JSON.stringify(response.data.payment_gateways_arr);
            //console.log(response);
            if(rootObject.edit){
               rootObject.editData = response.data.editData;
               rootObject.loadEditData();
            }else{
               loader.hide();
            }

         })
         .catch(function (error) {
            console.log(error)
            let alertmessage = "";
            for (var prop in error.response.data) {
               alertmessage += ' '+error.response.data[prop]
            }
            console.log(alertmessage);
            loader.hide();
            rootObject.com_errorHandel(error);
         });
      },

      mounted: function() {
         $(".select2").select2();
      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>